import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchVideos,
  createVideo,
  updateVideo,
  deleteVideo,
} from '../../api/videoApi' // Adjust the import path as necessary

export const fetchVideosThunk = createAsyncThunk(
  'video/fetchVideos',
  async (_, thunkAPI) => {
    try {
      const response = await fetchVideos()
      if (response.success && Array.isArray(response.videos)) {
        return response.videos // Ensure we're returning an array
      } else {
        // Handle the case where the response does not include an array of videos as expected
        return thunkAPI.rejectWithValue(
          response.message || 'Invalid videos data'
        )
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'An error occurred')
    }
  }
)

export const createVideoThunk = createAsyncThunk(
  'video/createVideo',
  async (videoData: FormData, thunkAPI) => {
    try {
      const response = await createVideo(videoData)
      if (response.success) {
        return response.video // Ensure this matches the structure of your CreateVideoResponse
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const updateVideoThunk = createAsyncThunk(
  'video/updateVideo',
  async (
    { videoId, videoData }: { videoId: string; videoData: FormData },
    thunkAPI
  ) => {
    try {
      const response = await updateVideo(videoId, videoData)
      console.log('Response', response)
      if (response.success) {
        return response.video // Assuming the API returns the updated video
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const deleteVideoThunk = createAsyncThunk(
  'video/deleteVideo',
  async (videoId: string, thunkAPI) => {
    try {
      const response = await deleteVideo(videoId)
      if (response.success) {
        return videoId // Return the ID of the deleted video for further processing
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)
